import { LearningResourceFeeDto } from './learningresourcefeedto';
import { pageDto } from './pagedto';

export class LearningResourceFeeResponse {

    listLearningResourceFeeDto: LearningResourceFeeDto[] = [];

    pageDto: pageDto = new pageDto({});
}